export default __webpack_public_path__ + "static/usa-flag-background-mobile-89d7f95829b3ba9c57bb5a9691de26b8.jpg";